export default __webpack_public_path__ + "locales/sr-Latn-RS/JavascriptSdk.json?hash=f4088f72ba41ca004ee2cb646bd918a8";